import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { forkJoin, from, Observable, catchError, delay, finalize, mergeMap, take, tap } from 'rxjs';

import { DocumentsSelect } from '../electronic-signature-form.component';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { API_ROUTE_DOCUMENT } from '@app/forms/subscription/api/api-router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export interface DialogData {
  animal: string;
  name: string;
}

@UntilDestroy()
@Component({
    selector: 'document-dialog',
    templateUrl: './document-dialog.component.html',
    styleUrls: ['./document-dialog.component.scss'],
    standalone: false
})
export class DocumentDialogComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  documents: DocumentsSelect[] = [];
  optionsLabel: FormControlOption[] = [
    // {
    //   label: "",
    //   value: "print",
    // },
    {
      label: '',
      value: 'doc',
    },
    {
      label: '',
      value: 'empty',
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private httpApiService: HttpApiService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    super(formConstructor);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);
    this.documents = this.subscriptionFacade?.getPledge()?.documents || [];
  }
  prev() {
    this.subscriptionFacade.previousStep();
  }
  onSubmit() {
    const docs: DocumentsSelect[] = this.form.value?.documentsForm;
    if (this.validate(docs)) {
      this.process(docs);
    }
  }
  validate(docs: DocumentsSelect[]): boolean {
    return !docs.some(doc => !doc.check.length);
  }
  process(docs: DocumentsSelect[]) {
    const docsDownLoads = this.findGedIdsDoc(docs);

    let nested: Observable<any>[] = [];

    if (docsDownLoads?.length) {
      nested.push(this.downloadDocumentsMerge(docsDownLoads));
    }
    this.loading = true;
    forkJoin(nested)
      .pipe(
        untilDestroyed(this),

        tap(() => {
          this.loading = true;
        }),
        catchError(err => {
          this.loading = false;
          return err;
        }),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe(() => {
        // this.subscriptionFacade.nextStep();
      });
  }
  findGedIdsDoc(docs: DocumentsSelect[]) {
    const docsDownLoaded = docs?.filter(doc => doc?.check?.includes('doc'));
    return docsDownLoaded?.map(item => item?.gedId);
  }
  private downloadDocumentsMerge(arr) {
    return from(arr).pipe(mergeMap(item => this.downloadDocument(item)));
    // .subscribe();
  }
  downloadDocument(docId) {
    const route = API_ROUTE_DOCUMENT.replace(
      ':accountId',
      this.entity?.accountId,
    ).replace(':documentId', docId);
    return this.httpApiService
      .getWithOptions(route, {
        responseType: 'arraybuffer',
      })
      .pipe(
        take(1),
        delay(1000),
        tap(resp => {
          this.createLink(resp, docId);
        }),
        catchError(err => {
          console.error(err);
          return err;
        }),
        finalize(() => {}),
      );
  }
  createLink(resp, docId) {
    var blob = new Blob([resp], { type: 'application/pdf' });
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = window.URL.createObjectURL(blob);
    link.download = `${docId}.pdf`;
    link.click();
    document.body.removeChild(link);

    this.cdr.detectChanges();
  }
}
